export enum FinancingPaymentStructure {
    'Standard' = 0,
    'Variation 1' = 1,
    'Variation 2' = 2
}
